import React from "react";
import { Phone } from "lucide-react";
import { CONTACT } from "../mock";

// Fixed bottom click-to-call bar shown only on mobile / tablet (hidden on lg+).
const MobileCallBar = () => (
  <a
    href={`tel:${CONTACT.phoneRaw}`}
    aria-label={`Tap here to call Roger at ${CONTACT.phone}`}
    className="lg:hidden fixed bottom-0 left-0 right-0 z-[60] flex items-center justify-center gap-3 bg-[#3a3736] text-white py-4 px-5 shadow-[0_-4px_20px_-6px_rgba(0,0,0,0.4)] active:bg-[#6f5f62] transition-colors duration-200"
    style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}
  >
    <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#b6a4a7] shrink-0">
      <Phone size={18} className="text-white" />
    </span>
    <span className="font-serif-el text-xl tracking-wide">Tap Here to Call Roger</span>
  </a>
);

export default MobileCallBar;
